import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { FinalCausalityListActionsProps } from './props';
import { FINAL_CAUSALITY_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const FinalCausalityListActions = ({
    id,
}: FinalCausalityListActionsProps) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${FINAL_CAUSALITY_EDIT}/${id}`, '_blank');
    };

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
